import { render, staticRenderFns } from "./ListClientePage.vue?vue&type=template&id=da6b55cc&"
import script from "./ListClientePage.vue?vue&type=script&lang=js&"
export * from "./ListClientePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports